import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ICluster} from '../interfaces'
import {BaseHttp} from "@atl/lacerta-ui-common";

@Injectable({
    providedIn: 'root'
})
export class ClusterHttpService extends BaseHttp {

    constructor(private http: HttpClient) {
        super();
    }

    getCluster(): Observable<ICluster[]> {
        const url = `${this.apiRoot}/cluster`;
        return this.http.get<ICluster[]>(url, {withCredentials: true})
    }
}
